/**
 * @file LandingNews/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

import { getString } from "config-api";

export const NEWS_PLAYLIST_VIDEO_SLUG = "apps-video";

export const OTHER_REGEX =
    /\/:section\(news\)\/:subSection+((\(canada\)\/:region\+\/)|([a-z]\+))/;

export const REGION_REGEX =
    /^\/:section\(news\)\/((:subSection\(canada\)\/:region\+$)|(covid-19$))/;

export const REGION_VIDEO_REGEX =
    /^news\/canada\/(british-columbia|ottawa|manitoba|montreal|new-brunswick|calgary|saskatchewan|saskatoon|nova-scotia|newfoundland-labrador|edmonton|windsor|toronto|thunder-bay|prince-edward-island|london|hamilton|kitchener-waterloo|north|sudbury)$/;

export const WEB_AB_TESTS_URL = getString("Client.stats.urlABTestsConfig");
